/* ==========================================================================
   TIENDA DRAGON - scripts propios (vanilla, sin librerias)
   ========================================================================== */
(function () {
  'use strict';

  // este archivo se incluye por separado en varias secciones; si dos de ellas
  // conviven en la misma pagina el navegador lo ejecuta dos veces y duplica
  // botones, observadores y timers (los videos "se peleaban" por jugar/pausar).
  if (window.__mtScriptsListo) return;
  window.__mtScriptsListo = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- utilidades --------------------------------------------------------- */
  // formato de dinero del pais del visitante, copiado de una muestra que pinta Shopify (1234,56)
  var FORMATO = (function () {
    var el = document.querySelector('[data-muestra-dinero]');
    var m = el ? (el.getAttribute('data-muestra-dinero') || '').match(/^(.*?)(\d[\d.,\s ']*\d)(.*)$/) : null;
    if (!m) return null;
    var num = m[2], dec = 0, sepDec = '.', sepMil = '';
    var d = num.match(/([.,])(\d{2})$/);
    if (d && num.replace(/\D/g, '') === '123456') { dec = 2; sepDec = d[1]; num = num.slice(0, -3); }
    var mil = num.match(/^1(\D+)2/); if (mil) sepMil = mil[1];
    return { pre: m[1], post: m[3], dec: dec, sepDec: sepDec, sepMil: sepMil };
  })();
  function dinero(centavos, simbolo) {
    if (!FORMATO) return (simbolo || '$') + (centavos / 100).toFixed(2);
    var v = (centavos / 100).toFixed(FORMATO.dec).split('.');
    var ent = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, FORMATO.sepMil);
    return FORMATO.pre + ent + (FORMATO.dec ? FORMATO.sepDec + v[1] : '') + FORMATO.post;
  }
  // tasa de cambio del pais del visitante (los descuentos fijos en dolares se convierten igual que en la caja)
  function tasa() { var r = window.Shopify && Shopify.currency ? parseFloat(Shopify.currency.rate) : 1; return r > 0 ? r : 1; }
  function dosCifras(n) { return n < 10 ? '0' + n : '' + n; }

  /* --- 1. Aparicion al hacer scroll -------------------------------------- */
  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('mt-visible');
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) { obs.observe(el); });
  }

  /* --- 2. Comparador encendida / apagada -------------------------------- */
  function initComparadores() {
    var cajas = document.querySelectorAll('[data-mt-comparador]');
    if (!cajas.length) return;

    cajas.forEach(function (caja) {
      if (caja.dataset.mtListo) return;
      caja.dataset.mtListo = '1';

      var frente = caja.querySelector('.mt-comp__frente');
      var asa = caja.querySelector('.mt-comp__asa');
      if (!frente || !asa) return;

      var arrastrando = false;

      function aplicar(p) {
        p = Math.max(0, Math.min(100, p));
        frente.style.clipPath = 'inset(0 0 0 ' + p + '%)';
        asa.style.left = p + '%';
        asa.setAttribute('aria-valuenow', Math.round(p));
      }
      function mover(clientX) {
        var r = caja.getBoundingClientRect();
        aplicar(((clientX - r.left) / r.width) * 100);
      }
      function iniciar(e) {
        arrastrando = true;
        caja.style.cursor = 'ew-resize';
        mover(e.touches ? e.touches[0].clientX : e.clientX);
      }
      function seguir(e) {
        if (!arrastrando) return;
        if (e.touches) { mover(e.touches[0].clientX); }
        else { e.preventDefault(); mover(e.clientX); }
      }
      function soltar() { arrastrando = false; caja.style.cursor = ''; }

      caja.addEventListener('mousedown', iniciar);
      caja.addEventListener('touchstart', iniciar, { passive: true });
      window.addEventListener('mousemove', seguir);
      window.addEventListener('touchmove', seguir, { passive: true });
      window.addEventListener('mouseup', soltar);
      window.addEventListener('touchend', soltar);

      asa.addEventListener('keydown', function (e) {
        var actual = parseFloat(asa.style.left) || 50;
        if (e.key === 'ArrowLeft') { e.preventDefault(); aplicar(actual - 4); }
        if (e.key === 'ArrowRight') { e.preventDefault(); aplicar(actual + 4); }
      });
    });
  }

  /* --- 3. Acordeones ----------------------------------------------------- */
  function initAcordeones() {
    var items = document.querySelectorAll('.mt-acordeon');
    if (!items.length) return;

    items.forEach(function (item) {
      if (item.dataset.mtListo) return;
      item.dataset.mtListo = '1';

      var btn = item.querySelector('.mt-acordeon__btn');
      var panel = item.querySelector('.mt-acordeon__panel');
      if (!btn || !panel) return;

      if (item.classList.contains('is-abierto')) {
        panel.style.height = 'auto';
        btn.setAttribute('aria-expanded', 'true');
      } else {
        panel.style.height = '0px';
        btn.setAttribute('aria-expanded', 'false');
      }

      btn.addEventListener('click', function () {
        var abierto = item.classList.contains('is-abierto');
        var alto = panel.scrollHeight;

        if (abierto) {
          panel.style.height = alto + 'px';
          requestAnimationFrame(function () { panel.style.height = '0px'; });
          item.classList.remove('is-abierto');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          panel.style.height = alto + 'px';
          item.classList.add('is-abierto');
          btn.setAttribute('aria-expanded', 'true');
          // red de seguridad: si la animacion no termina, el contenido se ve igual
          setTimeout(function () {
            if (item.classList.contains('is-abierto')) panel.style.height = 'auto';
          }, 500);
        }
      });
    });
  }

  /* --- 4. Cuenta atras compartida por toda la tienda --------------------- */
  // Un reloj NUEVO de 20 min cada vez que alguien entra a la tienda (cada visita); si recarga o cambia de pagina en la misma visita, sigue corriendo.
  // Fase 1: los minutos del ajuste (20). Fase 2: 5 min de "ultima oportunidad".
  // Fase 3: oferta caducada para siempre en ese navegador (00:00).
  var CLAVE_RELOJ = 'mt_oferta_fin_visita';
  var MINUTOS_ULTIMA = 5;

  function leerNum(k) {
    try { var v = parseInt(window.sessionStorage.getItem(k) || '0', 10); return isNaN(v) ? 0 : v; }
    catch (e) { return 0; }
  }

  function initRelojes() {
    var relojes = document.querySelectorAll('[data-mt-reloj]');
    if (!relojes.length) return;
    var textos = document.querySelectorAll('[data-mt-reloj-texto]');

    var minutos = parseInt(relojes[0].getAttribute('data-minutos') || '20', 10);
    var fin = leerNum(CLAVE_RELOJ);
    if (!fin) {
      fin = Date.now() + minutos * 60 * 1000;
      try { window.sessionStorage.setItem(CLAVE_RELOJ, String(fin)); } catch (e) {}
    }
    var finUltima = fin + MINUTOS_ULTIMA * 60 * 1000;
    var intervalo = null;

    function pintar() {
      var ahora = Date.now();
      if (ahora >= finUltima) {
        // se acabo la ultima oportunidad: empieza otra ronda completa (nunca 00:00)
        fin = ahora + minutos * 60 * 1000;
        finUltima = fin + MINUTOS_ULTIMA * 60 * 1000;
        try { window.sessionStorage.setItem(CLAVE_RELOJ, String(fin)); } catch (e) {}
      }
      var fase = ahora < fin ? 'normal' : 'ultima';
      var hasta = fase === 'normal' ? fin : finUltima;
      var resto = fase === 'caducada' ? 0 : Math.max(0, hasta - ahora);
      var t = Math.floor(resto / 1000);
      var h = Math.floor(t / 3600);
      var m = Math.floor((t % 3600) / 60);
      var s = t % 60;
      var txt = (h > 0 ? dosCifras(h) + ':' : '') + dosCifras(m) + ':' + dosCifras(s);
      relojes.forEach(function (r) { r.textContent = txt; });
      textos.forEach(function (el) {
        if (!el.hasAttribute('data-normal')) el.setAttribute('data-normal', el.textContent.trim());
        var nuevo = el.getAttribute('data-normal');
        if (fase === 'ultima') nuevo = el.getAttribute('data-ultima') || nuevo;
        if (fase === 'caducada') nuevo = el.getAttribute('data-caducada') || nuevo;
        if (el.textContent !== nuevo) el.textContent = nuevo;
      });
      document.documentElement.setAttribute('data-mt-oferta', fase);
      if (fase === 'caducada' && intervalo) { clearInterval(intervalo); intervalo = null; }
    }
    pintar();
    if (document.documentElement.getAttribute('data-mt-oferta') !== 'caducada') {
      intervalo = setInterval(pintar, 1000);
    }
  }

  /* --- 5. "X personas viendo esto" + barra de unidades ------------------- */
  function initEscasez() {
    document.querySelectorAll('[data-mt-viendo]').forEach(function (el) {
      if (el.dataset.mtListo) return;
      el.dataset.mtListo = '1';
      var min = parseInt(el.getAttribute('data-min') || '9', 10);
      var max = parseInt(el.getAttribute('data-max') || '28', 10);
      var n = Math.floor(Math.random() * (max - min + 1)) + min;
      el.textContent = n;
      setInterval(function () {
        n += Math.random() < 0.5 ? -1 : 1;
        if (n < min) n = min + 1;
        if (n > max) n = max - 1;
        el.textContent = n;
      }, 9000);
    });

    document.querySelectorAll('[data-mt-barra-stock]').forEach(function (el) {
      if (el.dataset.mtListo) return;
      el.dataset.mtListo = '1';
      var pct = parseInt(el.getAttribute('data-pct') || '18', 10);
      requestAnimationFrame(function () {
        setTimeout(function () { el.style.width = pct + '%'; }, 300);
      });
    });
  }

  /* --- 6. Avisos de compras recientes (prueba social) -------------------- */
  function initPruebaSocial() {
    var caja = document.querySelector('[data-mt-social]');
    if (!caja || caja.dataset.mtListo) return;
    caja.dataset.mtListo = '1';

    var avisos = JSON.parse(caja.getAttribute('data-avisos') || '[]');
    if (!avisos.length) return;

    var primero = parseInt(caja.getAttribute('data-primero') || '8', 10) * 1000;
    var visible = parseInt(caja.getAttribute('data-visible') || '6', 10) * 1000;
    var pausa = parseInt(caja.getAttribute('data-pausa') || '14', 10) * 1000;

    var elNombre = caja.querySelector('[data-mt-social-nombre]');
    var elProd = caja.querySelector('[data-mt-social-producto]');
    var elHace = caja.querySelector('[data-mt-social-hace]');
    var cerrar = caja.querySelector('[data-mt-social-cerrar]');
    var elFoto = caja.querySelector('[data-mt-social-foto]');
    var fotoFuego = caja.getAttribute('data-foto-fuego') || '';
    var fotoHielo = caja.getAttribute('data-foto-hielo') || '';
    var i = 0;
    var apagado = false;

    if (cerrar) {
      cerrar.addEventListener('click', function () {
        apagado = true;
        caja.classList.remove('is-visible');
      });
    }

    function mostrar() {
      if (apagado) return;
      var a = avisos[i % avisos.length];
      i++;
      if (elNombre) elNombre.textContent = a.nombre;
      if (elProd) elProd.textContent = a.producto;
      if (elHace) elHace.textContent = a.hace;
      if (elFoto) {
        var nueva = a.foto;
        if (!nueva) {
          var esHielo = /ice|azul|blue/i.test(a.producto || '');
          nueva = esHielo ? fotoHielo : fotoFuego;
        }
        if (nueva) elFoto.src = nueva;
      }
      caja.classList.add('is-visible');
      setTimeout(function () {
        caja.classList.remove('is-visible');
        setTimeout(mostrar, pausa);
      }, visible);
    }
    setTimeout(mostrar, primero);
  }

  /* --- 7. Pagina de producto -------------------------------------------- */
  function initProducto() {
    var raiz = document.querySelector('[data-mt-producto]');
    if (!raiz || raiz.dataset.mtListo) return;
    raiz.dataset.mtListo = '1';

    var imgPrincipal = raiz.querySelector('[data-mt-principal]');
    var minis = raiz.querySelectorAll('[data-mt-mini]');
    var moneda = raiz.getAttribute('data-moneda') || '$';
    var textoAgotado = raiz.getAttribute('data-texto-agotado') || 'Sold out';

    /* pide la foto al ancho justo: sin esto el navegador se baja el original entero */
    function conAncho(src, w) {
      if (!src) return src;
      if (src.indexOf('width=') !== -1) return src;
      if (src.indexOf('/cdn/') === -1 && src.indexOf('cdn.shopify') === -1) return src;
      return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
    }
    /* nombre del archivo, para comparar la foto grande con su miniatura */
    function clave(src) {
      if (!src) return '';
      return src.split('?')[0].split('/').pop();
    }
    var precargadas = {};
    function precargar(src) {
      var u = conAncho(src, 1000);
      if (!u || precargadas[u]) return;
      var i = new Image();
      i.decoding = 'async';
      i.src = u;
      precargadas[u] = i;
    }

    function ponerImagen(src, alt) {
      if (!imgPrincipal || !src) return;
      var u = conAncho(src, 1000);
      if (clave(imgPrincipal.currentSrc || imgPrincipal.src) === clave(u)) return;
      var pintar = function () {
        imgPrincipal.src = u;
        if (alt != null) imgPrincipal.alt = alt;
        imgPrincipal.style.opacity = '1';
      };
      var previa = precargadas[u] || new Image();
      if (!precargadas[u]) { precargadas[u] = previa; previa.decoding = 'async'; previa.src = u; }
      if (previa.complete && previa.naturalWidth) {
        /* ya esta en memoria: cambio seco, sin parpadeo */
        pintar();
      } else {
        imgPrincipal.style.opacity = '.45';
        previa.addEventListener('load', pintar, { once: true });
        previa.addEventListener('error', pintar, { once: true });
      }
    }
    if (imgPrincipal) imgPrincipal.style.transition = 'opacity .12s linear';

    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        minis.forEach(function (m) { m.classList.remove('is-activa'); });
        mini.classList.add('is-activa');
        ponerImagen(mini.getAttribute('data-src-grande'), mini.getAttribute('data-alt'));
      });
    });

    /* ---- variantes ---- */
    var datos = raiz.querySelector('[data-mt-variantes]');
    var variantes = [];
    if (datos) {
      try { variantes = JSON.parse(datos.textContent); } catch (e) { variantes = []; }
    }

    var inputId = raiz.querySelector('[data-mt-variante-id]');
    var inputCant = raiz.querySelector('[data-mt-cantidad-form]');
    var inputPack = raiz.querySelector('[data-mt-pack]');
    var elPrecio = raiz.querySelector('[data-mt-precio]');
    var elAntes = raiz.querySelector('[data-mt-antes]');
    var elDesc = raiz.querySelector('[data-mt-descuento]');
    var btn = raiz.querySelector('[data-mt-anadir]');
    var btnTexto = raiz.querySelector('[data-mt-anadir-texto]');
    var barra = document.querySelector('[data-mt-barra]');
    var barraPrecio = document.querySelector('[data-mt-barra-precio]');
    var textoComprar = btnTexto ? btnTexto.textContent.trim() : 'Anadir al carrito';

    var vActual = variantes.length ? variantes[0] : null;

    function seleccionadas() {
      var out = [];
      raiz.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
        var act = grupo.querySelector('.mt-prod__valor.is-activo');
        out.push(act ? act.getAttribute('data-valor') : null);
      });
      return out;
    }

    function buscarVariante() {
      var sel = seleccionadas();
      if (!sel.length) return variantes[0] || null;
      for (var i = 0; i < variantes.length; i++) {
        var ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] !== null && variantes[i].options[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) return variantes[i];
      }
      return null;
    }

    function actualizarVariante(cambiarFoto) {
      var v = buscarVariante();
      if (!v) return;
      vActual = v;

      if (inputId) inputId.value = v.id;
      var fotosTier = raiz.querySelectorAll('[data-tier-fotos]');
      for (var ft = 0; ft < fotosTier.length; ft++) {
        var mapa = (fotosTier[ft].getAttribute('data-tier-fotos') || '').split(';');
        var titulo = (v.title || '').toLowerCase();
        for (var mm = 0; mm < mapa.length; mm++) {
          var corte = mapa[mm].indexOf('=');
          if (corte > 0) {
            var claveTxt = mapa[mm].slice(0, corte);
            if (titulo.indexOf(claveTxt) !== -1) { fotosTier[ft].src = mapa[mm].slice(corte + 1); break; }
          }
        }
      }
      if (elPrecio) elPrecio.textContent = dinero(v.price, moneda);
      if (elAntes) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          elAntes.textContent = dinero(v.compare_at_price, moneda);
          elAntes.style.display = '';
          if (elDesc) {
            elDesc.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
            elDesc.style.display = '';
          }
        } else {
          elAntes.style.display = 'none';
          if (elDesc) elDesc.style.display = 'none';
        }
      }
      if (btn) {
        btn.disabled = !v.available;
        if (btnTexto) btnTexto.textContent = v.available ? textoComprar : textoAgotado;
      }
      var galeriaFija = raiz.getAttribute('data-galeria-fija') === '1';
      if (cambiarFoto && !galeriaFija && v.featured_image && v.featured_image.src) {
        ponerImagen(v.featured_image.src, v.featured_image.alt || '');
        minis.forEach(function (m) {
          m.classList.toggle('is-activa', clave(m.getAttribute('data-src-grande')) === clave(v.featured_image.src));
        });
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
      // los desplegables de pack que siguen la raza de arriba
      raiz.querySelectorAll('[data-duo-sel][data-sync-raza]').forEach(function (s) {
        if (String(s.value) !== String(v.id)) s.value = String(v.id);
        fotoDeSel(s);
      });
      refrescarPacks();
    }

    function fotoDeSel(sel) {
      var caja = sel.closest('[data-duo-caja]');
      if (!caja) return;
      var img = caja.querySelector('[data-duo-foto="' + sel.getAttribute('data-duo-sel') + '"]');
      var op = sel.options[sel.selectedIndex];
      if (img && op && op.getAttribute('data-foto')) img.src = op.getAttribute('data-foto');
    }

    function elegirRazaPorId(id) {
      for (var i = 0; i < variantes.length; i++) {
        if (String(variantes[i].id) === String(id)) {
          var nombre = variantes[i].options[0];
          var botones = raiz.querySelectorAll('[data-mt-opcion] .mt-prod__valor');
          for (var b = 0; b < botones.length; b++) {
            if (botones[b].getAttribute('data-valor') === nombre) { botones[b].click(); return; }
          }
        }
      }
    }

    raiz.querySelectorAll('[data-mt-opcion] .mt-prod__valor').forEach(function (b) {
      b.addEventListener('click', function () {
        var grupo = b.closest('[data-mt-opcion]');
        grupo.querySelectorAll('.mt-prod__valor').forEach(function (o) { o.classList.remove('is-activo'); });
        b.classList.add('is-activo');
        actualizarVariante(true);
      });
    });

    /* ---- packs (compra y ahorra) ---- */
    var bundle = raiz.querySelector('[data-mt-bundle]');
    var tiers = bundle ? bundle.querySelectorAll('[data-tier]') : [];
    var addons = bundle ? bundle.querySelectorAll('[data-addon]') : [];

    function tierActivo() {
      for (var i = 0; i < tiers.length; i++) {
        if (tiers[i].classList.contains('is-activo')) return tiers[i];
      }
      return tiers[0] || null;
    }

    function refrescarPacks() {
      if (!bundle || !vActual) return;
      var unidad = vActual.price;
      var antesUnidad = (vActual.compare_at_price && vActual.compare_at_price > unidad)
        ? vActual.compare_at_price : unidad;

      tiers.forEach(function (t) {
        var cant = parseInt(t.getAttribute('data-cantidad') || '1', 10);
        var pct = parseFloat(t.getAttribute('data-descuento') || '0');
        // El precio real es siempre el del producto por la cantidad.
        // El "ahorro" que se muestra es contra el precio tachado (efecto visual).
        var porU = unidad;
        var total = unidad * cant;
        // HOLYPAWS: el descuento del combo es real (descuento automatico de Shopify): se ve el mismo precio que se cobra
        if (pct > 0 && cant > 1) { total = unidad * cant - Math.floor(unidad * pct / 100) * cant; porU = Math.round(total / cant); }
        var antes = antesUnidad * cant;
        // duo (dos productos distintos): precios reales del pais del visitante
        // total = precio A + precio B - descuento automatico
        var elAh = t.querySelector('[data-tier-ahorro]');
        var vPackSolo = t.getAttribute('data-pack-variante');
        if (vPackSolo && t.getAttribute('data-duo') !== '1') {
          // pack con precio propio y sin desplegables (el marco): se cobra ese precio, tal cual
          total = parseInt(t.getAttribute('data-pack-precio') || '0', 10);
          antes = parseInt(t.getAttribute('data-pack-antes') || '0', 10);
          porU = total;
        }
        if (t.getAttribute('data-duo') === '1') {
          var cjD = t.querySelector('[data-duo-caja]');
          var sels = cjD ? cjD.querySelectorAll('[data-duo-sel]') : [];
          if (sels.length) {
            var suma = 0, sumaAntes = 0;
            Array.prototype.forEach.call(sels, function (s) {
              var o = s.options[s.selectedIndex];
              if (!o) return;
              suma += parseInt(o.getAttribute('data-precio') || '0', 10);
              sumaAntes += parseInt(o.getAttribute('data-antes') || '0', 10);
            });
            var vPack = t.getAttribute('data-pack-variante');
            if (vPack) {
              // el pack es un producto con su propio precio: no se suma ni se descuenta nada
              total = parseInt(t.getAttribute('data-pack-precio') || '0', 10);
              antes = parseInt(t.getAttribute('data-pack-antes') || '0', 10);
              porU = Math.round(total / sels.length);
            } else {
              var desc = Math.min(Math.round(parseInt(t.getAttribute('data-duo-descuento') || '0', 10) * tasa()), suma);
              total = suma - desc;
              porU = Math.round(total / sels.length);
              antes = sumaAntes;
            }
            if (elAh) elAh.textContent = (t.getAttribute('data-duo-ahorro-texto') || 'save') + ' ' + dinero(desc, moneda);
          }
        }
        var ahorroPct = antes > 0 ? Math.round((1 - total / antes) * 100) : 0;

        var elT = t.querySelector('[data-tier-total]');
        var elA = t.querySelector('[data-tier-antes]');
        var elU = t.querySelector('[data-tier-unidad]');
        if (elT) elT.textContent = dinero(total, moneda);
        if (elA) elA.textContent = dinero(antes, moneda); if (elA) elA.style.display = (antes > total) ? '' : 'none';
        if (elU) elU.textContent = dinero(porU, moneda);
        t.setAttribute('data-total', total);
        t.setAttribute('data-ahorro-pct', ahorroPct);
        var elP = t.querySelector('[data-tier-pct]');
        if (elP) elP.textContent = ahorroPct + '% dto.'; if (elP) elP.style.display = (ahorroPct > 0) ? '' : 'none';

        // la barra fija de movil ensena SIEMPRE el pack que esta elegido
        if (barraPrecio && t.classList.contains('is-activo')) {
          var bB = barraPrecio.querySelector('b');
          var bS = barraPrecio.querySelector('s');
          if (bB) bB.textContent = dinero(total, moneda);
          if (bS) {
            if (antes > total) { bS.textContent = dinero(antes, moneda); bS.style.display = ''; }
            else { bS.style.display = 'none'; }
          }
        }
      });

      sincronizarFormulario();
    }

    function textoPack(t) {
      if (!t || !vActual) return '';
      var cant = parseInt(t.getAttribute('data-cantidad') || '1', 10);
      if (cant < 2) return '';
      var total = parseInt(t.getAttribute('data-total') || '0', 10);
      var antesU = (vActual.compare_at_price && vActual.compare_at_price > vActual.price)
        ? vActual.compare_at_price : vActual.price;
      var ahorro = Math.max(0, antesU * cant - total);
      var ahorroTxt = ahorro > 0 ? ' · save ' + dinero(ahorro, moneda) : '';

      if (t.getAttribute('data-duo') === '1') {
        var cj = t.querySelector('[data-duo-caja]');
        var nombres = [];
        Array.prototype.forEach.call(cj ? cj.querySelectorAll('[data-duo-sel]') : [], function (s) {
          var o = s.options[s.selectedIndex];
          if (o) nombres.push(o.textContent.trim());
        });
        return 'SET: ' + nombres.join(' + ');
      }

      if (t.getAttribute('data-combo') === '1' && variantes.length >= cant) {
        var nombres = [];
        for (var k = 0; k < cant; k++) nombres.push(variantes[k].title);
        return 'COMBO ' + nombres.join(' + ') + ' · ' + cant +
               ' keepsakes, one of each' + ahorroTxt;
      }

      var color = '';
      var act = raiz.querySelector('[data-mt-opcion] .mt-prod__valor.is-activo');
      if (act) color = ' ' + act.getAttribute('data-valor');
      return cant + ' keepsakes' + (color ? ' (' + color.trim() + ')' : '') + ahorroTxt;
    }

    function sincronizarFormulario() {
      var t = tierActivo();
      if (!t) return;
      var cant = parseInt(t.getAttribute('data-cantidad') || '1', 10);
      if (inputCant) inputCant.value = cant;
      var express = raiz.querySelector('.mt-express');
      if (express) {
        var esCombo = (t.getAttribute('data-combo') === '1' && variantes.length >= cant) || t.getAttribute('data-duo') === '1' || !!t.getAttribute('data-pack-variante');
        express.classList.toggle('mt-express--oculto', esCombo);
      }
      if (inputPack) { inputPack.value = textoPack(t); }
      // el marco no lleva raza: se esconde el selector de arriba
      var sinRaza = t.getAttribute('data-sin-raza') === '1';
      raiz.querySelectorAll('[data-mt-opcion]').forEach(function (o) { o.classList.toggle('mt-ref__opcion--oculta', sinRaza); });
      var elResumen = bundle ? bundle.querySelector('[data-mt-resumen]') : null;
      if (elResumen) {
        var extra = 0;
        addons.forEach(function (a) {
          if (a.checked) extra += parseInt(a.getAttribute('data-precio') || '0', 10);
        });
        var total = parseInt(t.getAttribute('data-total') || '0', 10) + extra;
        elResumen.textContent = dinero(total, moneda);
      }
    }

    // duo: marcar el paquete y cambiar la foto al elegir
    function activarTier(t) {
      if (!t) return;
      tiers.forEach(function (o) { o.classList.remove('is-activo'); });
      t.classList.add('is-activo');
      var radio = t.querySelector('input[type=radio]');
      if (radio) radio.checked = true;
      sincronizarFormulario();
      refrescarPacks();
    }

    raiz.querySelectorAll('[data-duo-sel]').forEach(function (sel) {
      function refrescarFoto() { fotoDeSel(sel); }
      // tocar un desplegable SIEMPRE selecciona su paquete
      sel.addEventListener('change', function () {
        if (sel.hasAttribute('data-sync-raza')) elegirRazaPorId(sel.value);
        refrescarFoto();
        refrescarPacks();
        activarTier(sel.closest('[data-tier]'));
      });
      sel.addEventListener('focus', function () { activarTier(sel.closest('[data-tier]')); });
      sel.addEventListener('click',  function (e) {
        e.stopPropagation();
        activarTier(sel.closest('[data-tier]'));
      });
      refrescarFoto();
    });

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        tiers.forEach(function (o) { o.classList.remove('is-activo'); });
        t.classList.add('is-activo');
        var radio = t.querySelector('input[type=radio]');
        if (radio) radio.checked = true;
        sincronizarFormulario();
        refrescarPacks();
      });
    });
    addons.forEach(function (a) { a.addEventListener('change', sincronizarFormulario); });

    /* ---- cantidad manual ---- */
    var cantVisible = raiz.querySelector('[data-mt-cantidad]');
    if (cantVisible) {
      var menos = raiz.querySelector('[data-mt-menos]');
      var mas = raiz.querySelector('[data-mt-mas]');
      function sincCant() {
        if (inputCant) inputCant.value = cantVisible.value;
      }
      if (menos) menos.addEventListener('click', function () {
        cantVisible.value = Math.max(1, (parseInt(cantVisible.value, 10) || 1) - 1);
        sincCant();
      });
      if (mas) mas.addEventListener('click', function () {
        cantVisible.value = Math.min(99, (parseInt(cantVisible.value, 10) || 1) + 1);
        sincCant();
      });
      cantVisible.addEventListener('change', sincCant);
    }

    /* ---- anadir al carrito (con extras) ---- */
    var form = raiz.querySelector('.mt-prod__form');

    function anadirTodo(e) {
      if (e) e.preventDefault();
      if (!vActual) return;
      var t = tierActivo();
      var cant = t ? parseInt(t.getAttribute('data-cantidad') || '1', 10)
                   : (cantVisible ? parseInt(cantVisible.value, 10) || 1 : 1);

      var items = [];
      var props = {};
      var txtPack = textoPack(t);
      if (txtPack) props['Your set'] = txtPack;

      if (t && t.getAttribute('data-duo') === '1') {
        // duo: una unidad de cada producto, con la variante que haya elegido
        var caja = t.querySelector('[data-duo-caja]');
        var sels = caja ? caja.querySelectorAll('[data-duo-sel]') : [];
        var idPack = t.getAttribute('data-pack-variante');
        if (idPack && sels.length) {
          // pack con precio propio: una linea, y las razas van apuntadas
          var propsPack = {};
          Object.keys(props).forEach(function (k) { propsPack[k] = props[k]; });
          Array.prototype.forEach.call(sels, function (s, i) {
            var o = s.options[s.selectedIndex];
            if (o) propsPack[sels.length === 1 ? 'Print' : 'Breed ' + (i + 1)] = o.textContent.trim();
          });
          items.push({ id: parseInt(idPack, 10), quantity: 1, properties: propsPack });
        } else if (sels.length) {
          // si repite raza, una sola linea con cantidad 2 en vez de dos lineas iguales
          var cuenta = {}, orden = [];
          Array.prototype.forEach.call(sels, function (s) {
            var id = parseInt(s.value, 10);
            if (!cuenta[id]) { cuenta[id] = 0; orden.push(id); }
            cuenta[id]++;
          });
          orden.forEach(function (id) {
            items.push({ id: id, quantity: cuenta[id], properties: props });
          });
        } else {
          items.push({ id: vActual.id, quantity: cant, properties: props });
        }
      } else if (t && t.getAttribute('data-pack-variante')) {
        // pack con precio propio y sin desplegables (el marco): una linea con su variante
        items.push({ id: parseInt(t.getAttribute('data-pack-variante'), 10), quantity: 1, properties: props });
      } else if (t && t.getAttribute('data-combo') === '1' && variantes.length >= cant) {
        // combo: una unidad de cada color, cada linea con su foto en el carrito
        for (var k = 0; k < cant; k++) {
          items.push({ id: variantes[k].id, quantity: 1, properties: props });
        }
      } else {
        items.push({ id: vActual.id, quantity: cant, properties: props });
      }

      addons.forEach(function (a) {
        if (a.checked) {
          items.push({ id: parseInt(a.getAttribute('data-variante'), 10), quantity: 1 });
        }
      });

      if (btn) { btn.disabled = true; if (btnTexto) btnTexto.textContent = (document.documentElement.lang || '').slice(0, 2) === 'es' ? 'Agregando...' : 'Adding...'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          if (btn) { btn.disabled = false; if (btnTexto) btnTexto.textContent = textoComprar; }
          // la pareja NO puede ir por el formulario nativo: mandaria 2 del mismo producto
          if (t && (t.getAttribute('data-duo') === '1' || t.getAttribute('data-pack-variante'))) return;
          if (form) form.submit();
        });
    }

    raiz.querySelectorAll('[data-mt-anadir-todo]').forEach(function (b) {
      b.addEventListener('click', anadirTodo);
    });
    if (form) form.addEventListener('submit', anadirTodo);

    /* ---- barra pegajosa de compra en movil ---- */
    if (barra) {
      document.body.classList.add('mt-con-barra');
      var btnBarra = barra.querySelector('button');
      if (btnBarra) btnBarra.addEventListener('click', anadirTodo);
      if ('IntersectionObserver' in window && btn) {
        var obsBarra = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            barra.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
          });
        }, { threshold: 0 });
        obsBarra.observe(btn);
      }
    }

    actualizarVariante(false);

    /* precarga en segundo plano: al elegir raza la foto ya esta lista */
    (function () {
      var arrancar = function () {
        variantes.forEach(function (v) {
          if (v.featured_image && v.featured_image.src) precargar(v.featured_image.src);
        });
        minis.forEach(function (m) { precargar(m.getAttribute('data-src-grande')); });
      };
      if (window.requestIdleCallback) { requestIdleCallback(arrancar, { timeout: 2500 }); }
      else { setTimeout(arrancar, 800); }
    })();
    refrescarPacks();
  }

  /* --- videos mp4 del tema: se cargan y se reproducen solo cuando estan cerca --- */
  function initVideosArchivo() {
    var vids = Array.prototype.slice.call(document.querySelectorAll('video[data-mt-video-archivo]'));
    if (!vids.length) return;
    // son bucles mudos y decorativos: se mueven siempre (incluso con "reducir movimiento" en el movil)
    var visibles = [];
    function cargar(v) {
      if (!v.getAttribute('src')) { v.preload = 'auto'; v.setAttribute('src', v.getAttribute('data-src')); v.load(); }
    }
    function jugar(v) {
      cargar(v);
      v.muted = true; v.defaultMuted = true; v.setAttribute('playsinline', '');
      var p = v.play();
      if (p && p.catch) p.catch(function () { /* se reintenta abajo */ });
    }
    function reintentar() {
      visibles.forEach(function (v) { if (v.paused) jugar(v); });
    }
    vids.forEach(function (v) {
      // en cuanto tiene datos, si esta a la vista, arranca (el play() previo pudo llegar antes de tiempo)
      ['loadeddata', 'canplay'].forEach(function (ev) {
        v.addEventListener(ev, function () { if (visibles.indexOf(v) > -1 && v.paused) jugar(v); });
      });
      // si se queda parado sin haber acabado (ahorro de bateria, cambio de pestana...), vuelve a empujar
      v.addEventListener('pause', function () {
        if (visibles.indexOf(v) > -1 && !v.ended) setTimeout(function () { if (v.paused && visibles.indexOf(v) > -1) jugar(v); }, 400);
      });
    });
    // primer toque o scroll: los moviles que bloquean el autoplay lo permiten tras una interaccion
    ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, reintentar, { passive: true, once: true });
    });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) reintentar(); });
    // vigilante: los que estan a la vista y siguen quietos, se empujan cada segundo y medio
    setInterval(reintentar, 1500);

    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { visibles.push(v); jugar(v); }); return; }

    // carga por cercania: los que estan a punto de verse se descargan ya; el resto, de uno en uno en reposo
    var cerca = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) cargar(e.target); });
    }, { rootMargin: '900px 900px', threshold: 0 });
    var vista = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target, k = visibles.indexOf(v);
        if (e.isIntersecting) { if (k < 0) visibles.push(v); jugar(v); }
        else { if (k > -1) visibles.splice(k, 1); v.pause(); }
      });
    }, { rootMargin: '120px 120px', threshold: 0.01 });
    vids.forEach(function (v) { cerca.observe(v); vista.observe(v); });

    var cola = vids.filter(function (v) { return !v.getAttribute('src'); });
    function siguiente() {
      var v = cola.shift();
      if (!v) return;
      if (v.getAttribute('src')) { siguiente(); return; }
      cargar(v);
      var hecho = false;
      function fin() { if (hecho) return; hecho = true; siguiente(); }
      v.addEventListener('canplaythrough', fin, { once: true });
      setTimeout(fin, 3500);
    }
    var reposo = function () { siguiente(); };
    if (window.requestIdleCallback) requestIdleCallback(reposo, { timeout: 3000 }); else setTimeout(reposo, 1500);
  }

  /* --- arranque ---------------------------------------------------------- */
  function initVideosManual() {
    // fila de videos de clientes: nada de autoplay (se trababan como un gif); se reproducen al darle a play, uno cada vez
    var items = Array.prototype.slice.call(document.querySelectorAll('.mt-ref-videos__item'));
    if (!items.length) return;
    var actual = null;
    items.forEach(function (item) {
      var v = item.querySelector('video');
      var btn = item.querySelector('[data-mt-rv-play]');
      if (!v || !btn) return;
      function pausar() {
        v.pause();
        item.classList.remove('is-jugando');
      }
      function jugar() {
        if (actual && actual !== item) {
          var vAnt = actual.querySelector('video');
          if (vAnt) vAnt.pause();
          actual.classList.remove('is-jugando');
        }
        actual = item;
        if (!v.getAttribute('src') && v.dataset.src) v.setAttribute('src', v.dataset.src);
        item.classList.add('is-jugando');
        var p = v.play();
        if (p && p.catch) p.catch(function () { item.classList.remove('is-jugando'); });
      }
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (v.paused) jugar(); else pausar();
      });
      v.addEventListener('click', function () {
        if (v.paused) jugar(); else pausar();
      });
      v.addEventListener('ended', pausar);
    });
  }

  function init() {
    initReveals();
    initComparadores();
    initAcordeones();
    initRelojes();
    initEscasez();
    initPruebaSocial();
    initVideosArchivo();
    initVideosManual();
    initProducto();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
